<template>
  <modal name="orderPanel" @before-open="beforeOpen" @opened="opened" @before-close="beforeClose" :clickToClose="true" :draggable="'.header'"
         :reset="true" :classes="['schedule','generalbox']"
         :adaptive="true"
          :height="800" :width="'80%'" :min-width="1000" :click-to-close="false">

    <div class="header">
      <h2>开放预约
      </h2>
      <div @click="close" class="close">
        <i class="iconfont icon-cha"></i>
      </div>
    </div>
    <div class="content">
      <ul class="conditionList">
        <li>
          <h2><span class="xin">*</span>请选择应用：</h2>
          <multiselect v-model="appName"
                       :options="systemList"
                       @select="selectSys"
                       :label="'name'"
                       placeholder="请选择应用名称"
                       :multiple="false"
                       :show-labels="false"
                       :clear-on-select="false"
                       :close-on-select="true"
                       :allow-empty="false"
                       :taggable="true"
          ></multiselect>
        </li>
        <br/>
        <li class="main">
          <div v-if="!this.appName" @click="infoEmptyNotice" class="maskPrevent"></div>
          <h2>请选择时间：</h2>
          <div class="weekTable">
            <div class="row title">
              <div class="col">周一</div>
              <div class="col">周二</div>
              <div class="col">周三</div>
              <div class="col">周四</div>
              <div class="col">周五</div>
              <div class="col">周六</div>
              <div class="col">周日</div>
            </div>
            <div class="row">
              <div class="col">
                <span>上午</span>
                <span>下午</span>
                <span>晚上</span>
              </div>
              <div class="col">
                <span>上午</span>
                <span>下午</span>
                <span>晚上</span>
              </div>
              <div class="col">
                <span>上午</span>
                <span>下午</span>
                <span>晚上</span>
              </div>
              <div class="col">
                <span>上午</span>
                <span>下午</span>
                <span>晚上</span>
              </div>
              <div class="col">
                <span>上午</span>
                <span>下午</span>
                <span>晚上</span>
              </div>
              <div class="col">
                <span>上午</span>
                <span>下午</span>
                <span>晚上</span>
              </div>
              <div class="col">
                <span>上午</span>
                <span>下午</span>
                <span>晚上</span>
              </div>

            </div>
            <div class="row handleArea">
              <div v-for="weekData in orderData" class="col">
                <span v-for="stepData in weekData.steps">
                  <input :checked="stepData.val" @click="selectStepAction(stepData,weekData,$event)" class="timeunit"
                         type="checkbox"/>
                  <p title="请填写可预约的人数：" v-show="stepData.val" class="orderPeople">人数</p>
                  <input v-show="stepData.val" v-model="stepData.count" class="textInput" type="text"
                         @change="inputStepAction(stepData,weekData)"/>
                </span>
              </div>

            </div>


          </div>
        </li>
        <br>
        <li>
          <h2>请选择排除日期段(下边列出的时间段不开放预约)：</h2>
          <div class="dateSelect">
            <flatPickr placeholder="请选择开始时间" :config="flatPickerConfig" v-model="excludeDateFrom"></flatPickr>&nbsp;&nbsp;~
            <flatPickr placeholder="请选择结束时间" :config="flatPickerConfig" v-model="excludeDateTo"></flatPickr>

            <button @click="addExcludeDate">添加</button>
          </div>
          <ul class="dateList">
            <li v-for="excludeDate in excludeDateList">{{excludeDate.starttime}} ~ {{excludeDate.endtime}} <span
                title="移除时间段" @click="removeExcludeDate(excludeDate.id)" class="remove"><i class="iconfont icon-cha"></i></span></li>
          </ul>
          <div class="pagination">
            <v-pagination
                @page-change="pageChange"
                @page-size-change="pageSizeChange"
                :total="totalCount"
                :pageIndex="pageNumber"
                :page-size="pageSize"
            ></v-pagination>
          </div>
        </li>
      </ul>
      <transition name='orderForm'>
        <div v-if="currentEditInfo" class="orderFormContainer">
          <order-form @saveAction="saveAction" @cancel="cancel" :payload="currentEditInfo"></order-form>
        </div>
      </transition>

    </div>

  </modal>
</template>

<script>
  //axios
  import axios from 'axios'
  //通信总线
  import Bus from 'common/js/bus.js';
  import apiConfig from 'common/js/api_config'
  import orderForm from 'components/order/orderForm'
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';
  import multiselect from 'vue-multiselect';

  //flat picker
  import flatPickr from 'vue-flatpickr-component';
  import {Mandarin} from 'flatpickr/dist/l10n/zh.js';

  const DEFAULT_ORDER_COUNT = 30;
  export default {
    name: "orderPanel",
    data() {
      return {
        appName: null,
        systemList: [],
        selectTime: [],

        /**
         * 预约数据
         */
        orderData: [
          {
            week: 1,
            steps: [
              {
                step: 0,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              },
              {
                step: 1,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              },
              {
                step: 2,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              }
            ]
          },
          {
            week: 2,
            steps: [
              {
                step: 0,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              },
              {
                step: 1,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              },
              {
                step: 2,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              }
            ]
          },
          {
            week: 3,
            steps: [
              {
                step: 0,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              },
              {
                step: 1,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              },
              {
                step: 2,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              }
            ]
          },
          {
            week: 4,
            steps: [
              {
                step: 0,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
              },
              {
                step: 1,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
              },
              {
                step: 2,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
              }
            ]
          },
          {
            week: 5,
            steps: [
              {
                step: 0,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              },
              {
                step: 1,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              },
              {
                step: 2,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              }
            ]
          },
          {
            week: 6,
            steps: [
              {
                step: 0,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              },
              {
                step: 1,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              },
              {
                step: 2,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              }
            ]
          },
          {
            week: 7,
            steps: [
              {
                step: 0,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              },
              {
                step: 1,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              },
              {
                step: 2,
                val: 0,
                count: DEFAULT_ORDER_COUNT,
                username: this.linkperson,
                tel: this.linkway,
                address: this.address,
              }
            ]
          },


        ],

        currentEditInfo: null,
        currentEditWeekInfo: null,
        //默认联系人
        linkperson: null,
        //默认联系方式
        linkway: null,
        //默认地址
        address: null,
        // 排除日期列表
        excludeDateList: [],
        // 日期选择器配置
        flatPickerConfig: {
          enableTime: false,
          dateFormat: "Y-m-d",
          locale: Mandarin,
        },
        excludeDateFrom: null,
        excludeDateTo: null,

        //排除日期段分页
        totalCount: null,
        pageNumber: 1,
        pageSize: 10
      }
    },
    computed: {
      checkCondition() {
        if (this.linkperson && this.linkway && this.address) {
          return false
        }
        return true
      }
    },

    methods: {
      ...mapMutations(['updateModalZIndex']),
      beforeOpen() {
        this.initSysList();
        this.initExcludeDate();
      },
      opened() {
        this.updateModalZIndex(this.$el)
      },
      cancel() {
        this.currentEditInfo = null
      },
      //读服务列表
      async initSysList() {
        let sysList = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getOrderAppList");
        sysList = sysList.data.data;
        this.systemList = sysList;
        if (sysList.length) {
          this.appName = sysList[0];
          this.selectSys(sysList[0]);
        }
      },
      //触发选择变化
      async fireChange() {

      },
      //将id转为时段键名
      convertIdToTimeStep(id) {
        id = parseInt(id);
        switch (id) {
          case 1:
            return "morning";
          case 2:
            return "afternoon";
          case 3:
            return "evening";
          default:
            console.log("convertIdToTimeStep参数异常");
        }
      },
      convertToLocalData() {

      },
      //选择系统
      async selectSys(selectedOption) {
        this.selectTime = [];
        if (!selectedOption) {
          return;
        }
        let timeData = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getOrder?sysId=" + selectedOption.appid);
        timeData = timeData.data.data;

        timeData.forEach((item, index) => {
          this.orderData[item.week - 1].steps[0].val = item.m_num ? 1 : 0;
          this.orderData[item.week - 1].steps[0].count = item.m_num;
          this.orderData[item.week - 1].steps[0].username = item.username;
          this.orderData[item.week - 1].steps[0].username = item.username;
          this.orderData[item.week - 1].steps[0].address = item.address;

          this.orderData[item.week - 1].steps[1].val = item.a_num ? 1 : 0;
          this.orderData[item.week - 1].steps[1].count = item.a_num;
          this.orderData[item.week - 1].steps[1].username = item.username;
          this.orderData[item.week - 1].steps[1].tel = item.username;
          this.orderData[item.week - 1].steps[1].address = item.address;

          this.orderData[item.week - 1].steps[2].val = item.e_num ? 1 : 0;
          this.orderData[item.week - 1].steps[2].count = item.e_num;
          this.orderData[item.week - 1].steps[2].username = item.username;
          this.orderData[item.week - 1].steps[2].tel = item.username;
          this.orderData[item.week - 1].steps[2].address = item.address;


        });

        if (timeData[0]) {
          this.linkperson = timeData[0].username
          this.linkway = timeData[0].tel
          this.address = timeData[0].address
        }

        // timeData.forEach((item,index)=>{
        //   let week=item.week;
        //   item.morning?this.selectTime.push(week+""+1):"";
        //   item.afternoon?this.selectTime.push(week+""+2):"";
        //   item.evening?this.selectTime.push(week+""+3):"";
        // })
      },

      close() {
        this.$modal.hide("orderPanel");
      },
      beforeClose () {
        Bus.$emit("modalSlidesClose")
      },
      async selectTimeAction(ev) {
        if (!this.appName) {
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "请先选择应用~"
          });
          this.selectTime = [];
          return;
        }
        console.log(ev);
        let checkState = ev.srcElement.checked ? 1 : 0;
        let val = ev.srcElement.value;
        let week = parseInt(val[0]);
        let tempRequestObj = {
          sysId: this.appName.appid,
          week,
          morning: -1,
          afternoon: -1,
          evening: -1
        };
        tempRequestObj[this.convertIdToTimeStep(val[1])] = checkState;

        let changeResp = await axios.post(apiConfig.REQUEST_URL + "/shall/front_saveOrder?" + this.$qs.stringify({
          sysId: tempRequestObj.sysId,
          week: tempRequestObj.week,
          morning: tempRequestObj.morning,
          afternoon: tempRequestObj.afternoon,
          evening: tempRequestObj.evening
        }));
        this.$notify({
          group: "global",
          title: "温馨提示",
          text: changeResp.data.msg
        })
      },


      //提示
      infoEmptyNotice() {
        this.$notify({
          group: "global",
          title: "温馨提示",
          text: "请先选择应用~"
        });
      },


      //选框变化触发
      async selectStepAction(step, week, ev) {
        if (!this.appName) {
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "请先选择应用~"
          });
          return;
        }

        if (step.val) {
          step.val = 0;
          step.count = 0;
          this.saveAction(0, {step, week})
        } else {
          this.currentEditInfo = step
          this.currentEditWeekInfo = week
          step.count = 30;
        }

      },

      //输入框变化触发
      async inputStepAction(step, week) {
        if (!this.appName) {
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "请先选择应用~"
          });
          return;
        }

        if (step.count <= 0) {
          step.val = 0;
          step.count = 0;
        }
        //请求

        let changeResp = await axios.post(apiConfig.REQUEST_URL + "/shall/front_saveOrder?" + this.$qs.stringify({
          sysId: this.appName.appid,
          week: week.week,
          type: step.step,
          num: step.count,
          username: step.username,
          tel: step.tel,
          address: step.address
        }));
        this.$notify({
          group: "global",
          title: "温馨提示",
          text: changeResp.data.msg
        })
      },
      //检查信息
      checkInfo() {
        if (!this.linkperson || !this.linkway || !this.address) {
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "请填写联系人、联系方式、办理地点~"
          });
          return
        }
      },
      async saveAction(ev, payload) {
        if (ev) {
          this.currentEditInfo.val = 1
          this.currentEditInfo.username = ev.username
          this.currentEditInfo.tel = ev.tel
          this.currentEditInfo.address = ev.address
          this.currentEditInfo.count = ev.count
        } else {
          ev = {}
          let changeResp = await axios.post(apiConfig.REQUEST_URL + "/shall/front_saveOrder?" + this.$qs.stringify({
            sysId: this.appName.appid,
            week: payload.week.week,
            type: payload.step.step,
            num: 0,
            username: payload.step.username,
            tel: payload.step.tel,
            address: payload.step.address
          }));
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "清除成功"
          })
          return
        }
        //请求
        let changeResp = await axios.post(apiConfig.REQUEST_URL + "/shall/front_saveOrder?" + this.$qs.stringify({
          sysId: this.appName.appid,
          week: this.currentEditWeekInfo.week,
          type: ev.payload.step,
          num: ev.count,
          username: ev.username,
          tel: ev.tel,
          address: ev.address
        }));
        this.$notify({
          group: "global",
          title: "温馨提示",
          text: changeResp.data.msg
        })
        if (changeResp.data.status) {
          this.currentEditInfo = null
        }

      },

      //排除日期分页处理
      pageChange(pageIndex) {

      },
      pageSizeChange(newPageSize) {

      },
      //获取指定日期字符串的时间戳
      getDateStamp(dateStr){
        if(!dateStr){
          return
        }
        dateStr=dateStr.replace(/-/g,'/')
        return new Date(dateStr).getTime()
      },
      //初始化排除日期
      async initExcludeDate() {

        let excludeDate = await axios.post(apiConfig.REQUEST_URL + '/shall/front_excludeOrderList?' + this.$qs.stringify({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber
        }))
        if (!excludeDate.data.status) {
          return
        }
        let info = excludeDate.data.data[0]
        this.totalCount = info.totalCount
        this.pageNumber = info.pageNumber
        this.excludeDateList = info.list
      },
      async addExcludeDate() {
        if (!this.excludeDateFrom || !this.excludeDateTo) {
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: '请选择开始日期和结束日期！'
          })
          return
        }
        //比对日期先后，控制提交
        if(this.getDateStamp(this.excludeDateFrom)>this.getDateStamp(this.excludeDateTo)){
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: '开始日期不能大于结束日期！'
          })
          return
        }

        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/front_setExcludeOrder?' + this.$qs.stringify({
          starttime: this.excludeDateFrom,
          endtime: this.excludeDateTo
        }))
        this.$notify({
          group: 'global',
          title: '温馨提示',
          text: resp.data.msg
        })
        this.excludeDateFrom=null
        this.excludeDateTo=null

        this.pageNumber=1
        this.initExcludeDate()
      },
      async removeExcludeDate(id) {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/front_removeExcludeOrder?id=' + id)
        this.$notify({
          group: 'global',
          title: '温馨提示',
          text: resp.data.msg
        })
        this.pageNumber=1
        this.initExcludeDate()
      }
    },
    components: {multiselect, orderForm, flatPickr},
    mounted() {

    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .multiselect
    border-radius 5px !important
  .v--modal-overlay .generalbox .header h2
    border-left: 3px solid #548edf;
  .content
    .conditionList
      padding 20px

      li
        margin-bottom 15px
        display inline-block
        margin-right 20px

        & > h2
          line-height 30px
          margin-bottom 10px
          font-size 14px
          color #666666

          .xin
            font-weight bold
            color #f00
            margin-right 5px

        & > input
          border 1px solid #cccccc
          width 100%
          height 24px
          line-height 24px
          font-size 14px
          color #666666
          padding 0 10px
          border-radius 13px

        .weekTable

          width 100%
          margin auto
          margin-top 10px
          border 1px solid #eeeeee

          & > .row
            width 100%

            &::after
              content ""
              display block
              width 100%
              clear both

            &.title > .col
              border-bottom 1px solid #eeeeee
              font-size 14px !important
              color #666666

            & > .col
              padding-top 5px
              width 14.2%
              float left
              font-size 0
              text-align center
              line-height 26px
              border-right 2px solid #548edf

              &:last-of-type
                border-right none

              & > span
                font-size 14px
                color #666666
                line-height 30px
                display inline-block
                /*height 60px*/
                width 33.3%
                float left
                position relative

                .textInput
                  width 60%
                  position static
                  left 0
                  right 0
                  margin auto
                  bottom 10px
                  display block
                  text-align center
                  border 1px solid #cccccc

          & > .handleArea
            & > .col
              & > span
                /*height 70px*/
                padding-bottom 10px

                .orderPeople
                  white-space nowrap
                  overflow hidden
                  text-overflow ellipsis
                  font-size 10px
                  width 100%
                  text-align center
                  border-top 1px solid #eeeeee

                .timeunit
                  line-height 20px

        .dateSelect
          margin-top 20px

          & >>> .flatpickr-input
            font-size 14px
            color #666666
            width 200px
            height 32px
            border-radius 5px
            text-align center
            border 1px solid #cccccc

          & > button
            width 80px
            height 32px
            line-height 24px
            border-radius 5px
            border none
            background-color #548edf
            font-size 14px
            color #ffffff
            outline none
            margin-left 20px
            transition 300ms

            &:hover
              background-color #0070d7

        .dateList
          width 100%
          margin-top 20px
          font-size 0

          li
            font-size 14px
            color #666666
            text-align center
            line-height 30px
            padding-left 15px
            padding-right 15px
            height 30px
            border-radius 5px
            box-shadow 2px 2px 6px #cccccc

            & > .remove
              color #999999
              display inline-block
              width 16px
              height 16px
              box-sizing content-box
              line-height 14px
              text-align center
              border-radius 50%
              cursor pointer
              transition 300ms
              padding 5px

              &:hover
                color #333333

              i
                font-size 16px

      li.main
        width 100%
        position relative

        .maskPrevent
          cursor pointer
          position absolute
          left 0
          right 0
          top 0
          bottom 0
          z-index 9
          background-color rgba(255, 255, 255, 0.5)

    .orderForm-enter, .orderForm-leave-to
      opacity 0

    .orderForm-enter-active, .orderForm-leave-active
      transition 300ms
</style>



// WEBPACK FOOTER //
// src/components/order/orderPanelModal.vue